<template>
  <BCard>
    <BRow class="mx-1 flex gap-2 items-center">
      <BButton
        class="button-ajukan"
        size="sm"
        @click="$router.go(-1)"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/illustration/arrow-left-white.svg"
          alt="left-arrow"
        >
      </BButton>
      <strong class="text-[20px] text-black font-semibold ml-1">
        Ajukan File Pembanding
      </strong>
    </BRow>
    <BRow>
      <div class="ml-2 mt-2 text-[#333] disini">
        Download Template Excel Pengecekan Rekonsiliasi
        <a
          :href="templateLinkExcel"
          target="_blank"
        >"Disini"</a>
      </div>
    </BRow>

    <BRow class="gap-[8px] w-full">
      <ValidationObserver
        v-slot="{ invalid }"
        class="w-full max-w-[450px]"
      >
        <BCol
          md="12"
          class="mt-2"
        >
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Tanggal Invoice
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Tanggal Invoice"
              rules="required"
            >
              <FlatPickr
                v-model="invoiceDate"
                class="datepicker-rekonsiliasi"
                :config="invoiceConfigDate"
                placeholder=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol
          md="12"
          class="mt-2"
        >
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Rentang Tanggal
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Rentang Tanggal"
              rules="required"
            >
              <FlatPickr
                class="datepicker-rekonsiliasi"
                :config="rangeDateConfig"
                placeholder=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Ekspedisi
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="ekspedisi"
              rules="required"
            >
              <VSelect
                v-model="idExpedition"
                :reduce="option => option.shipping_name"
                :options="expeditionList"
                label="shipping_name"
                class="rekonsiliasi-vselect"
                :clearable="false"
                placeholder="Pilih Ekspedisi"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Status Order
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="status order"
              rules="required"
            >
              <VSelect
                v-model="statusOrder"
                :reduce="option => option"
                :options="statusOrderList"
                class="rekonsiliasi-vselect"
                multiple
                :clearable="false"
                placeholder="Pilih Status Order"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Metode Pembayaran
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="metode pembayaran"
              rules="required"
            >
              <VSelect
                v-model="paymentMethod"
                :reduce="option => option"
                :options="paymentMethodList"
                class="rekonsiliasi-vselect"
                multiple
                :clearable="false"
                placeholder="Pilih Metode Pembayaran"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol md="12">
          <BFormGroup
            label-cols-md="4"
            label-class="text-7 text-black"
          >
            <template #label>
              Upload File
            </template>
            <ValidationProvider
              ref="provider"
              v-slot="{ errors }"
              rules="required"
            >
              <b-form-file
                ref="file"
                type="file"
                accept=".xls,xlsx,.xlsm,.xlsb,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                class="hidden"
                @change="handleFileChange"
              />
              <div
                class="border border-red py-[5px] px-[10px] rounded-[6px] flex justify-between"
              >
                <div class="flex gap-[10px]">
                  <button
                    class=" outline-none rounded-[6px] text-[12px] text-white px-[6px]"
                    :class="uploadFile ? 'bg-[#C2C2C2]' : 'bg-[#F95031]'"
                    @click="handleClickUpload"
                  >
                    Upload File
                  </button>
                  <div v-if="uploadFile !== null">
                    {{ uploadFile.name }}
                  </div>
                  <div
                    v-if="uploadFile === null"
                    class="text-[#C2C2C2]"
                  >
                    No file choosen
                  </div>
                </div>
                <button
                  v-if="uploadFile !== null"
                  class="outline-none"
                  @click="resetUploadImage"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close.svg"
                    alt="close"
                  >
                </button>
              </div>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol
          md="12"
          class="mt-2"
        >
          <BFormGroup
            label-cols-md="4"
            label-class=" text-7 text-black"
          >
            <template #label>
              Keterangan
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Keterangan"
              rules="max:100"
            >
              <b-form-textarea
                id="keterangan"
                v-model="description"
                size="sm"
                maxlength="100"
                placeholder="Tulis keterangan di sini"
              />
              <div class="d-flex justify-content-between">
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="d-flex justify-content-end">{{ description.length || 0 }}/100</small>
              </div>
            </ValidationProvider>
          </BFormGroup>
        </BCol>
        <BCol>
          <button
            :disabled="invalid || !uploadFile || rangeDate === null"
            :class="
              invalid || !uploadFile || rangeDate === null ? 'is_disable_button' : 'is_active_button'
            "
            @click.prevent="submit()"
          >
            {{ !loadingSubmit ? 'Ajukan File Excel' : '' }}
            <b-spinner
              v-if="loadingSubmit"
              small
            />
          </button>
        </BCol>
      </ValidationObserver>
    </BRow>
  </BCard>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FlatPickr from 'vue-flatpickr-component'
import { mapState } from 'vuex'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import VSelect from 'vue-select'
import '@core/scss/vue/libs/vue-select.scss'
import { required } from '@validations'
import { alertError, alertSuccess } from '@toast'
import ToastificationContentVue from '@core/components/toastification/ToastificationContent.vue'
import { newAxiosIns } from '@/libs/axios'
import { createDateConfig } from './config'

export default {
  components: {
    ValidationProvider,
    FlatPickr,
    VSelect,
    ValidationObserver,
  },
  data() {
    return {
      loadingSubmit: false,
      templateLinkExcel:
        'https://storage.googleapis.com/komerce//Template%20Reconciliation.xlsx',
      name: '',
      uploadFile: null,
      notes: '',
      idExpedition: null,
      rangeDate: null,
      statusOrder: null,
      paymentMethod: null,
      statusOrderList: ['Diterima', 'Retur'],
      paymentMethodList: ['COD', 'Bank Transfer'],
      invoiceConfigDate: createDateConfig({ mode: 'single' }),
      rangeDateConfig: createDateConfig({
        mode: 'range',
        onChange: (selectedDates, dateStr, instance) => {
          this.rangeDate = {
            start_date: instance.formatDate(selectedDates[0], 'Y-m-d'),
            end_date: instance.formatDate(selectedDates[1], 'Y-m-d'),
          }
        },
      }),
      alertError,
      alertSuccess,
      submitErrors: '',
      invoiceDate: null,
      required,
      description: '',
    }
  },
  computed: {
    ...mapState('filter', ['expeditionList']),
  },
  mounted() {
    if (this.expeditionList.length === 0) {
      this.$store.dispatch('filter/getUpdateExpedition')
    }
  },
  methods: {
    async handleFileChange(e) {
      const { valid } = await this.$refs.provider.validate(e)

      if (valid) {
        const fileExcell = this.$refs.file.files[0]
        this.uploadFile = fileExcell
      }
    },
    handleClickUpload() {
      this.$refs.file.$el.childNodes[0].click()
    },
    resetUploadImage() {
      this.$refs.file.reset()
      this.uploadFile = null
    },
    async submit() {
      this.loadingSubmit = true

      const formData = new FormData()
      formData.append('invoice_date', this.invoiceDate)
      formData.append('start_date', this.rangeDate.start_date)
      formData.append('end_date', this.rangeDate.end_date)
      formData.append('order_status', this.statusOrder.join(', '))
      formData.append('payment_method', this.paymentMethod.join(', '))
      formData.append('shipping', this.idExpedition === 'J&T' ? 'JnT' : this.idExpedition)
      formData.append('reconciliation_file', this.uploadFile)
      formData.append('description', this.description)

      const url = '/reconciliation/api/v1/reconciliations'
      await newAxiosIns
        .post(url, formData)
        .then(() => {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: 'File Berhasil Diajukan',
              text: 'File berhasil diajukan',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.loadingSubmit = false
          this.$router.push({ name: 'rekonsiliasi' })
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContentVue,
              props: {
                title: 'File Gagal Diajukan',
                icon: 'AlertCircleIcon',
                text: 'File gagal diajukan',
                variant: 'danger',
              },
            },
            { timeout: 1000 },
          )
          this.loadingSubmit = false
        })
    },
  },
}
</script>

<style  scoped>
@import './Rekonsiliasi.scss';

</style>
